import { Section } from '../../sections/builders/section_builder';
import { IDefineCommand, IQuery } from 'core-ts-types';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { RemoveSectionSelectionCommand } from '../../../components/section_selections/commands/remove_section_selection_command';

export type RemoveFromRegisterSectionsCommand = (sectionIds: Section['id'][]) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'removeFromRegisterSectionsCommand',
    (
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      defineCommandORM: IDefineCommand,
      removeSectionSelectionCommand: RemoveSectionSelectionCommand
    ) => {
      return defineCommandORM('removeFromRegisterSectionsCommand', (deferred, sectionIds: Section['id'][]) => {
        sectionIds.forEach((id) => {
          ngRegisterSectionsDatasource.del(id);
          removeSectionSelectionCommand(id);
        });
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/remove_from_register_sections_command.ts